module.exports = __webpack_public_path__ + "static/media/lightbulb_0.0c3a2f65.png";